import MechanismFieldParser from '../base/mechanism_field_parser'

import Hook from '../../../models/mechanism/hook'

export default class HookParser extends MechanismFieldParser {
  constructor(context) {
    super(context)
  }

  parseDefinition (trigger, procedure) {
    return this.add(new Hook(trigger.replace(/^on /, '').replaceAll(' ', ':'), procedure))
  }
}
